module.exports = __webpack_public_path__ + "static/media/contact.a45d47b5.jpg";